import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'bootDash';
  @HostListener('window:beforeunload')
  unloadHandler(event) {
     localStorage.clear();
     sessionStorage.clear()
  }
}
